var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;
window.pluralize = require('pluralize');

// const feather = require('feather-icons');

// require('moment');
// import * as Popper from "@popperjs/core"
// require('bootstrap-five');
// require('bootstrap-five/js/dist/alert');
// require('bootstrap-five/js/dist/button');
// require('bootstrap-five/js/dist/carousel');
// require('bootstrap-five/js/dist/util');
// require('bootstrap-five/js/dist/collapse');
// require('bootstrap-five/js/dist/dropdown');
require('bootstrap-five/js/dist/modal');
// require('bootstrap-five/js/dist/popover');
// require('bootstrap-five/js/dist/scrollspy');
require('bootstrap-five/js/dist/tab');
require('bootstrap/js/dist/tooltip');
require('bootstrap-datepicker');

// import * as bootstrap from 'bootstrap';
// import { Tooltip, Toast, Popover } from 'bootstrap';

// import Swiper from 'swiper/bundle';
import Swiper from 'swiper';
import { Navigation, Thumbs } from 'swiper/modules';
require('magnific-popup');


// feather.replace();

window.trackingEvent = function trackingEvent(eventName, data) {

    let event = new CustomEvent(eventName, {
        detail: data,
    });
    window.dispatchEvent(event);
}


// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded
$(function() {

    $('.datepicker').datepicker({
        format: 'dd/mm/yyyy', // Customize date format
        autoclose: true,      // Close the datepicker automatically after selection
        todayHighlight: true,  // Highlight the current date
        orientation: 'bottom'
    });

     $('.btn-reset').on('click', function() {
         $('.form-filter input').val('');
     });

     setTimeout(function() {
         $("#alert-fade").fadeOut();
     }, 3500);

     if ($('.announcement').length > 0) {
        $('.announcement').each(function() {
            var $announcement = $(this);
            var announcementKey = 'announcement' + $announcement.data('id');


            // Show announcement
            if (window.sessionStorage.getItem(announcementKey)) {
                $announcement.addClass('d-none');
                 $('body').addClass('hide-announcement');

            } else {
                // Hide announcement
                $announcement.removeAttr('style').removeClass('d-none').addClass('d-flex');
            }

            $announcement.find('button.close').on('click', function() {
                $announcement.addClass('d-none');
                window.sessionStorage.setItem(announcementKey, 'Announcement hidden');
                 $('body').addClass('hide-announcement');
            })
        });
    }

});

const $sidebarButtons = document.querySelectorAll('.btn-sidebar-toggle');
const $wrapper = document.querySelector('#wrapper');

$sidebarButtons.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
        e.preventDefault();
        $wrapper.classList.toggle('sidebar-toggle');
    });
});

//-----------------------------------------------
// Global AJAX / Application Functions
//-----------------------------------------------
function initAjaxJS() {

}